import { httpsCallable } from 'firebase/functions';
import { functions } from '../config';

/**
 * 招待リンク生成レスポンスの型定義
 */
export interface CreateReferralInvitationResponse {
  success: boolean;
  data: {
    invitation_id: string;
    referral_url: string;
    expires_at: string;
    inviter_reward_amount: number;
    invitee_reward_amount: number;
  };
}

/**
 * トークン検証レスポンスの型定義
 */
export interface ValidateReferralTokenResponse {
  valid: boolean;
  data?: {
    inviter_company_name: string;
    invitee_reward_amount: number;
  };
  error?: {
    code: string;
    message: string;
  };
}

/**
 * リファラル付与レスポンスの型定義
 */
export interface RedeemReferralInvitationResponse {
  success: boolean;
  data: {
    invitation_id: string;
    reward_amount: number;
    inviter_company_name: string;
  };
}

/**
 * 招待リンクを生成する
 */
export const createReferralInvitation = async (): Promise<CreateReferralInvitationResponse> => {
  const callable = httpsCallable<Record<string, never>, CreateReferralInvitationResponse>(
    functions,
    'createReferralInvitation',
  );
  const result = await callable({});
  return result.data;
};

/**
 * 招待トークンを検証する
 */
export const validateReferralToken = async (
  referralToken: string,
): Promise<ValidateReferralTokenResponse> => {
  const callable = httpsCallable<{ referral_token: string }, ValidateReferralTokenResponse>(
    functions,
    'validateReferralToken',
  );
  const result = await callable({ referral_token: referralToken });
  return result.data;
};

/**
 * リファラル招待を適用してクレジットを付与する
 * 登録完了直後に呼び出す
 */
export const redeemReferralInvitation = async (
  referralToken: string,
  inviteeCompanyId: string,
): Promise<RedeemReferralInvitationResponse> => {
  const callable = httpsCallable<
    { referral_token: string; invitee_company_id: string },
    RedeemReferralInvitationResponse
  >(functions, 'redeemReferralInvitation');
  const result = await callable({
    referral_token: referralToken,
    invitee_company_id: inviteeCompanyId,
  });
  return result.data;
};
